import ButtonComponent from '../../Button'
import { WidgetContentFilesDownloadButton } from '../WidgetContentFiles'

function ProfileDocumentsWidgetHeaderDownloadAllButton(props) {
  return (
    <WidgetContentFilesDownloadButton
      {...props}
      Button={ButtonComponent.Flat}
      tooltipKey='Common.ProfileWidgetDocumentsHeaderDownloadAllBtnTooltipKey'
    />
  )
}

export default ProfileDocumentsWidgetHeaderDownloadAllButton
